/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import * as React from "react";
import styled from "styled-components";

import { redesignTheme } from "../theme/theme";

type InfoTextProps = {
  children: React.ReactChild | React.ReactChild[];
};

const StyledHelpText = styled.div`
  color: ${redesignTheme.color.gray900};
  margin: 0;
  display: flex;
`;

const InfoText = ({ children }: InfoTextProps): React.ReactElement => {
  return (
    <StyledHelpText>
      <div>{children}</div>
    </StyledHelpText>
  );
};

export default InfoText;
